/* eslint-disable no-undef */
const mapStyle = [
    {
      featureType: 'all',
      elementType: 'geometry.fill',
      stylers: [
        {
          weight: '2.00',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#9c9c9c',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f2f2f2',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#eeeeee',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#7b7b7b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#46bcec',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#c8d7d4',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#070707',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
  ];

  const selectors = {
    map: '[data-js-map]',
};

function parseCoordinates(coordinates) {
    if (!coordinates || typeof coordinates !== 'string') return;

    const parts = coordinates.split(',');

    const latitude = parseFloat(parts[0]);
    const longitude = parseFloat(parts[1]);

    if (isNaN(latitude) || isNaN(longitude)) {
      window.console.error('Invalid latitude or longitude');
      return null;
    }

    return {latitude, longitude};
  }

const initMap = (mapElement) => {
    if(!mapElement) return;
    const desktopQuery = window.matchMedia(`(min-width: 1000px)`);
    const markersData = mapElement.dataset.markers;
    const mapSettings = mapElement.dataset.settings;
    const infoWindows = document.querySelectorAll(selectors.infoWindows);

    if (!markersData || !mapSettings) return;

    const markersJson = JSON.parse(markersData);
    const mapSettingsJson = JSON.parse(mapSettings);
    const customMapMarkerIcon = mapElement.dataset?.markerImageUrl;

    const coordinates = {
      desktop: parseCoordinates(mapSettingsJson?.map_start_position),
      mobile: parseCoordinates(mapSettingsJson?.map_start_position_mobile),
    };

    const zoom = {
      desktop: mapSettingsJson?.map_zoom || 11,
      mobile: mapSettingsJson?.map_zoom_mobile || 11,
    };

    const view = desktopQuery.matches ? 'desktop' : 'mobile';
    const longitude = coordinates[view]?.longitude;
    const latitude = coordinates[view]?.latitude;

    const mapOptions = {
      zoom: zoom[view],
      center: new google.maps.LatLng(latitude, longitude),
      styles: window.dgStoreMapStyle || mapStyle,
      streetViewControl: false,
      draggable: false,
      zoomControl: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      mapTypeControl: false,
      fullscreenControl: false,
      gestureHandling: 'none',
    };

    let map = new google.maps.Map(mapElement, mapOptions);

    markersJson.forEach(function (markerData, i) {
      const coordinates = markerData.coordinates.split(',');
      const latLng = new google.maps.LatLng(parseFloat(coordinates[0]), parseFloat(coordinates[1]));

      const customMarkerIcon = {
        url: customMapMarkerIcon ?? null,
        scaledSize: new google.maps.Size(50, 50),
      };

      const marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: markerData.title,
        icon: customMarkerIcon ?? null,
        disableDefaultUI: true,
      });

      marker.addListener('click', function () {
        infoWindows.forEach((infoWindow) => {
          if (markersJson[i].id === infoWindow.dataset.id) {
            infoWindow.classList.toggle(classes.activeInfoWindow);
          } else {
            infoWindow.classList.remove(classes.activeInfoWindow);
          }
        });
      });
    });

    return map;
  }

const initStoreLocation = () => {
    const mapElement = document.querySelector(selectors.map);
    initMap(mapElement);
  };


document.addEventListener('DOMContentLoaded', () => {
    initStoreLocation();
  });